import { useMemo, useState } from "react";

/**
 * Options filtered by the search query (searchText, case-insensitive),
 * the selected one taken out to be shown first.
 *
 * @param {{ key: string, value: string, searchText: string }[]} options - key is unique, value is what is chosen
 * @param {string} value - value of the selected option
 */
const useOptionSearch = (options, value) => {
  const [query, setQuery] = useState("");
  const normalizedQuery = query.trim().toLowerCase();

  const { selectedOption, otherOptions } = useMemo(() => {
    const matchingOptions = normalizedQuery
      ? options.filter((option) => option.searchText.toLowerCase().includes(normalizedQuery))
      : options;

    const selected = matchingOptions.find((option) => option.value === value) || null;

    return {
      selectedOption: selected,
      otherOptions: matchingOptions.filter((option) => option !== selected),
    };
  }, [normalizedQuery, options, value]);

  return { query, setQuery, selectedOption, otherOptions };
};

export default useOptionSearch;
